import React from 'react';

export const MapPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { latitude, longitude, markerLabel } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{
        width: '100%',
        height: '300px',
        background: 'linear-gradient(135deg, #E0F2FE 0%, #BAE6FD 100%)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #93C5FD',
        position: 'relative'
      }}>
      <div style={{
        fontSize: '48px',
        marginBottom: '8px'
      }}>📍</div>
      <div style={{
        fontSize: '14px',
        fontWeight: '600',
        color: '#1E40AF'
      }}>{markerLabel || 'Map Location'}</div>
      <div style={{
        fontSize: '12px',
        color: '#3B82F6',
        marginTop: '4px'
      }}>
        {latitude || '0'}, {longitude || '0'}
      </div>
      </div>
    </div>
  );
};
